import * as z from 'zod';

z.config({
  customError: (issue) => {
    const { input, code, origin, expected, minimum, maximum } = issue;
    if (code === 'too_small') {
      if (input === '') {
        return '入力してください';
      }
      return `${minimum}${origin === 'string' ? '文字' : ''}以上で入力してください`;
    } else if (code === 'too_big') {
      return `${maximum}${origin === 'string' ? '文字' : ''}以下で入力してください`;
    } else if (code === 'invalid_type' && expected === 'number') {
      if (input === '') {
        return '入力してください';
      }
      return '数字を入力してください';
    }
    return;
  },
});

export const memberNameValidation = {
  check: (val: string) => !/(iichi|ｉｉｃｈｉ|いいち|イイチ|support|ｓｕｐｐｏｒｔ|サポート)/i.test(val),
  message: '使用できないフレーズが含まれています',
};
